import { Ref, ref } from "@vue/composition-api"
import { HttpResponse } from "../../api/request"
import { BookingModel } from "../../models/booking.model"
import { api } from "../../api"
import { useCallbacksTCS } from "../merchant-callbacks/callbacks-tcs.reactive"

const stopBookingError = ref<string | undefined>()

export function useStopBooking() {
  const isStopBookingPending = ref(false)
  const { callbacks } = useCallbacksTCS()

  async function stopBooking(
    booking: Ref<BookingModel>,
  ): Promise<HttpResponse<BookingModel>> {
    isStopBookingPending.value = true
    stopBookingError.value = undefined
    const response = await api.stopBooking(booking.value.referenceId)
    isStopBookingPending.value = false
    if (response.wasSuccessful && response.data) {
      booking.value.state = response.data.state
      booking.value.stoppedAt = new Date(response.data.stoppedAt as any)

      // Call the corresponding callback to the TCS Frontend App (Via Webview JS Bridge)
      callbacks.termination()
    } else if (response.status === 409) {
      stopBookingError.value = (response.error as any)?.name ?? "activeServiceTransaction"
    } else {
      // TODO: Clarify with Christian if thats okay to call error in that case
      callbacks.error()
    }

    return response
  }

  return { stopBooking, isStopBookingPending, stopBookingError }
}
